import { ProductDetailsSchema } from "@redotech/redo-model/product2/product2-composite-types";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getProductDetails = {
  name: "getProductDetails" as const,
  input: z.object({ productId: zExt.objectId() }),
  output: z.object({ product: ProductDetailsSchema.nullable() }),
};
